export enum PATHS {
  HOME = '/',
  ACCOUNT = 'account',
  CUSTOMER = 'customer',
  PRODUCT = 'product',
  SIGN_IN = 'login',
  SIGN_IN_MOCK = 'login-mock',
  OFFERS_CONFIGURATOR = 'offers-configurator',
  ORDER = 'order',
  RECHARGES = 'recharges',
  ENERGY = 'energy',
}
export enum SALES_PATHS {
  SALES = '/sale',
  SALES_START = '/sale/start',
}
